import { SingleProductForReview } from './SingleProductForReview';

export const AllProductReadyForReview = ({
  order,
  selectedProductId,
  setSelectedProductId,
}) => {
  return (
    <div className="flex space-x-2 overflow-x-auto custom-scrollbar-hidden ">
      {order?.items
        ?.filter((item) => item?.hasReviewed === false)
        .map((item) => (
          <SingleProductForReview
            key={item.productID}
            product={item}
            selectedProductId={selectedProductId}
            setSelectedProductId={setSelectedProductId}
          />
        ))}
    </div>
  );
};
